// extracted by mini-css-extract-plugin
export default {"center":"Loading_center__TlYLU","ldsRing":"Loading_ldsRing__7fJ8H","lds-ring":"Loading_lds-ring__3YYh1"};